export default [
  {
    path: '/dashboard',
    name: 'DashboardView',
    component: () =>
      import(/* webpackChunkName: "erc20" */ '@/views/ERC20/DashboardView.vue'),
    meta: { title: 'Dashboard', group: 'erc20' },
  },
  {
    path: '/manual_transfer_request',
    name: 'AirdropAddView',
    component: () =>
      import(
        /* webpackChunkName: "erc20" */ '@/views/ERC20/AirdropAddView.vue'
      ),
    meta: { title: 'Manual Transfer Request', group: 'erc20' },
  },
  {
    path: '/manual_transfer_processing',
    name: 'AirdropView',
    component: () =>
      import(/* webpackChunkName: "erc20" */ '@/views/ERC20/AirdropView.vue'),
    meta: { title: 'Manual Transfer Processing', group: 'erc20' },
  },
  {
    path: '/manual_transfer_history',
    name: 'AirdropHistoryView',
    component: () =>
      import(
        /* webpackChunkName: "erc20" */ '@/views/ERC20/AirdropHistoryView.vue'
      ),
    meta: { title: 'Manual Transfer History', group: 'erc20' },
  },
  {
    path: '/withdrawal_request',
    name: 'ERC20WithdrawView',
    component: () =>
      import(
        /* webpackChunkName: "erc20-withdraw" */ '@/views/ERC20/ERC20WithdrawView.vue'
      ),
    meta: { title: 'Withdrawal Request', group: 'erc20' },
  },
  {
    path: '/withdrawal_restriction',
    name: 'ERC20WithdrawBlacklistView',
    component: () =>
      import(
        /* webpackChunkName: "erc20-withdraw" */ '@/views/ERC20/ERC20WithdrawBlacklistView.vue'
      ),
    meta: { title: 'Withdrawal Restriction', group: 'erc20' },
  },
  {
    path: '/withdrawal_history',
    name: 'ERC20WithdrawHistoryView',
    component: () =>
      import(
        /* webpackChunkName: "erc20-withdraw" */ '@/views/ERC20/ERC20WithdrawHistoryView.vue'
      ),
    meta: { title: 'Withdrawal History', group: 'erc20' },
  },
  {
    path: '/pending_withrawal',
    name: 'ERC20WithdrawHoldView',
    component: () =>
      import(
        /* webpackChunkName: "erc20-withdraw" */ '@/views/ERC20/ERC20WithdrawHoldView.vue'
      ),
    meta: { title: 'Pending Withdrawal', group: 'erc20' },
  },
  {
    path: '/transaction_status',
    name: 'ERC20TransactionStatusView',
    component: () =>
      import(
        /* webpackChunkName: "erc20" */ '@/views/ERC20/ERC20TransactionStatusView.vue'
      ),
    meta: { title: 'Transaction Status', group: 'erc20' },
  },
  {
    path: '/rejection_history',
    name: 'ERC20WithdrawRefusalView',
    component: () =>
      import(
        /* webpackChunkName: "erc20-withdraw" */ '@/views/ERC20/ERC20WithdrawRefusalView.vue'
      ),
    meta: { title: 'Rejection History', group: 'erc20' },
  },
  {
    path: '/skyplay_wallet',
    name: 'SKYPlayWalletView',
    component: () =>
      import(
        /* webpackChunkName: "erc20" */ '@/views/ERC20/SKYPlayWalletView.vue'
      ),
    meta: { title: 'SKYPlay Wallet', group: 'erc20' },
  },
  {
    path: '/skyplay_deposit_list',
    name: 'ERC20DepositHistoryView',
    component: () =>
      import(
        /* webpackChunkName: "erc20" */ '@/views/ERC20/ERC20DepositHistoryView.vue'
      ),
    meta: { title: 'Deposit History', group: 'erc20' },
  },
  {
    path: '/transfers_erc20',
    name: 'ERC20TransferView',
    component: () =>
      import(
        /* webpackChunkName: "erc20" */ '@/views/ERC20/ERC20TransferView.vue'
      ),
    meta: { title: 'ERC20 Transfers', group: 'erc20' },
  },
  {
    path: '/holders_erc20',
    name: 'ERC20HolderView',
    component: () =>
      import(
        /* webpackChunkName: "erc20" */ '@/views/ERC20/ERC20HolderView.vue'
      ),
    meta: { title: 'ERC20 Holders', group: 'erc20' },
  },
  {
    path: '/lockup_schedules',
    name: 'ERC20LockupSchedules',
    component: () =>
      import(
        /* webpackChunkName: "erc20" */ '@/views/ERC20/ERC20LockupSchedules.vue'
      ),
    meta: { title: 'Lockup Schedules', group: 'erc20' },
  },
  {
    path: '/transaction_erc20',
    name: 'ERC20TransactionView',
    component: () =>
      import(
        /* webpackChunkName: "erc20" */ '@/views/ERC20/ERC20TransactionView.vue'
      ),
    meta: { title: 'ERC20 Transaction', group: 'erc20' },
  },
  {
    path: '/token_tracker_rules',
    name: 'RulesView',
    component: () =>
      import(/* webpackChunkName: "erc20" */ '@/views/ERC20/RulesView.vue'),
    meta: { title: 'Token Tracker Rules', group: 'erc20' },
  },
]
